export default "__VITE_ASSET__Bbru188e__"